import { defineMessages } from 'react-intl';

/**
 * design: trial-upsell a2. The frame draws the Download case in full and names the second row of
 * the other three ("Share with the watermark", "Post with the watermark", "Download 9 files with
 * the watermark"); the other lines of those three follow the same pattern.
 */
export const watermarkChoiceMessages = defineMessages({
  title: { id: 'app.sml.upsell.watermark.choice.title', defaultMessage: 'This file has the MUSIC24 watermark.' },
  titleZip: {
    id: 'app.sml.upsell.watermark.choice.title.zip',
    defaultMessage: 'The files of this zip have the MUSIC24 watermark.',
  },
  cleanDownload: { id: 'app.sml.upsell.watermark.choice.clean.download', defaultMessage: 'Download the clean file' },
  cleanShare: { id: 'app.sml.upsell.watermark.choice.clean.share', defaultMessage: 'Share the clean file' },
  cleanPost: { id: 'app.sml.upsell.watermark.choice.clean.post', defaultMessage: 'Post the clean file' },
  cleanZip: { id: 'app.sml.upsell.watermark.choice.clean.zip', defaultMessage: 'Download the clean files' },
  cleanDetail: {
    id: 'app.sml.upsell.watermark.choice.clean.detail',
    defaultMessage: '{width} × {height}, no watermark. With a plan, from {price} a month.',
  },
  cleanDetailNoSize: {
    id: 'app.sml.upsell.watermark.choice.clean.detailNoSize',
    defaultMessage: 'Full size, no watermark. With a plan, from {price} a month.',
  },
  cleanDetailNoPrice: {
    id: 'app.sml.upsell.watermark.choice.clean.detailNoPrice',
    defaultMessage: 'Full size, no watermark. With a plan.',
  },
  newFiles: { id: 'app.sml.upsell.watermark.choice.new', defaultMessage: 'No watermark on each new file' },
  newFilesDetail: {
    id: 'app.sml.upsell.watermark.choice.new.detail',
    defaultMessage: 'Full size, no watermark. With a plan, from {price} a month.',
  },
  newFilesDetailNoPrice: {
    id: 'app.sml.upsell.watermark.choice.new.detailNoPrice',
    defaultMessage: 'Full size, no watermark. With a plan.',
  },
  remove: { id: 'app.sml.upsell.watermark.remove', defaultMessage: 'Remove the watermark' },
  keepDownload: {
    id: 'app.sml.upsell.watermark.choice.keep.download',
    defaultMessage: 'Download with the watermark',
  },
  keepShare: { id: 'app.sml.upsell.watermark.choice.keep.share', defaultMessage: 'Share with the watermark' },
  keepPost: { id: 'app.sml.upsell.watermark.choice.keep.post', defaultMessage: 'Post with the watermark' },
  keepZip: {
    id: 'app.sml.upsell.watermark.choice.keep.zip',
    defaultMessage: 'Download {count, plural, one {# file} other {# files}} with the watermark',
  },
  keepDetailPreview: {
    id: 'app.sml.upsell.watermark.choice.keep.detailPreview',
    defaultMessage: '{width} × {height} preview, as it is now.',
  },
  keepDetail: { id: 'app.sml.upsell.watermark.choice.keep.detail', defaultMessage: 'As it is now.' },
  keepActionDownload: {
    id: 'app.sml.upsell.watermark.choice.keep.action.download',
    defaultMessage: 'Download the preview',
  },
  keepActionShare: { id: 'app.sml.upsell.watermark.choice.keep.action.share', defaultMessage: 'Share the preview' },
  keepActionPost: { id: 'app.sml.upsell.watermark.choice.keep.action.post', defaultMessage: 'Post the preview' },
  keepActionZip: { id: 'app.sml.upsell.watermark.choice.keep.action.zip', defaultMessage: 'Download the previews' },
  fineTrial: {
    id: 'app.sml.upsell.watermark.choice.fine.trial',
    defaultMessage:
      'A plan also makes clean copies of the {count, plural, one {# file} other {# files}} you made on the trial. You pay no credits for them.',
  },
  fineFree: {
    id: 'app.sml.upsell.watermark.choice.fine.free',
    defaultMessage:
      'A plan also makes clean copies of the {count, plural, one {# file} other {# files}} you made on Free. You pay no credits for them.',
  },
  ownerNote: {
    id: 'app.sml.upsell.watermark.ownerNote',
    defaultMessage: 'Ask the workspace owner to upgrade.',
  },
  ownerNoteDetail: {
    id: 'app.sml.upsell.watermark.choice.ownerDetail',
    defaultMessage: 'A plan gives the workspace the clean file in full size.',
  },
  ownerNoteDetailNew: {
    id: 'app.sml.upsell.watermark.choice.ownerDetailNew',
    defaultMessage: 'A plan makes each new file of the workspace in full size, with no watermark.',
  },
  close: { id: 'app.sml.upsell.watermark.close', defaultMessage: 'Close' },
});
